export enum TIMERS {
  CLOSE_BUTTON_TIMER = 'CLOSE_BUTTON_TIMER',
  AUTO_CLOSE_TIMER = 'AUTO_CLOSE_TIMER',
  SKAN_TIMER = 'SKAN_TIMER'
}
